import { useCallback } from 'react';
import { useObservableCacheItem } from '../../cache/observable-cache-hooks';
import { useObservableCache } from '../../cache/observable-cache-provider';
import { DirectConnectSession } from '../api/direct-connect-session.provider';

const CACHE_KEY = 'dc-session';

const useDirectConnectSetSession = () => {
  const cache = useObservableCache();

  const callback = useCallback(
    async (session: DirectConnectSession) => {
      await cache.setItem(CACHE_KEY, session);
    },
    [cache]
  );

  return callback;
};

const useDirectConnectRemoveSession = () => {
  const cache = useObservableCache();

  const callback = useCallback(async () => {
    await cache.deleteItem(CACHE_KEY);
  }, [cache]);

  return callback;
};

const useDirectConnectGetSession = () => {
  return useObservableCacheItem<DirectConnectSession>(CACHE_KEY);
};

const useDirectConnectGetSessionLazy = () => {
  const cache = useObservableCache();

  const callback = useCallback(async (): Promise<
    DirectConnectSession | undefined
  > => {
    const result = await cache.getItem<DirectConnectSession>(CACHE_KEY);
    return result ?? undefined;
  }, [cache]);

  return callback;
};

export {
  useDirectConnectSetSession,
  useDirectConnectRemoveSession,
  useDirectConnectGetSession,
  useDirectConnectGetSessionLazy,
};
